import React from 'react';
import { motion } from 'framer-motion';
import { Moon, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-navy text-cream pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-84">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-85">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 rounded-full bg-purple blur-3xl" data-id="element-86"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-72 h-72 rounded-full bg-coral blur-3xl opacity-50" data-id="element-87"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-6 flex justify-center" data-id="element-89">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-white/10 text-sm font-medium tracking-wide backdrop-blur-sm border border-white/10" data-id="element-90">
            <Moon className="w-4 h-4 mr-2 text-coral" data-id="element-91" />
            Para mujeres 40+
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight mb-6 font-serif" data-id="element-92">
          Si te despertás a las 3AM, <br className="hidden sm:block" data-id="element-93" />
          <span className="text-coral italic" data-id="element-94">no estás rota</span>: estás en un
          escenario.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-xl sm:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto font-light" data-id="element-95">
          Un protocolo de 12 minutos para cuando ya estás despierta (sin
          pantallas, sin pelea).
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="bg-white/5 backdrop-blur-md rounded-2xl p-6 sm:p-8 mb-10 text-left border border-white/10 shadow-xl" data-id="element-96">
          <p className="text-lg text-gray-200 leading-relaxed mb-4" data-id="element-97">
            "Hay un momento que solo lo entiende quien lo vive. Te dormís. Por
            fin. Y de repente… abrís los ojos."
          </p>
          <p className="text-lg text-gray-200 leading-relaxed" data-id="element-98">
            No es "me desperté un segundo". Es ese despertar entre las 2 y las
            4AM donde el cuerpo se enciende: calor raro, corazón rápido, mente
            que se prende, una incomodidad que no te deja volver.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-99">
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="inline-flex items-center px-8 py-4 text-lg font-semibold rounded-full bg-coral text-navy hover:bg-white transition-all duration-300 shadow-lg hover:shadow-coral/20 transform hover:-translate-y-1" data-id="element-100">
            Quiero el Kit
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-101" />
          </button>
          <p className="mt-4 text-sm text-gray-400" data-id="element-102">
            Descarga inmediata • PDF Digital
          </p>
        </motion.div>
      </div>
    </section>;
}